<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
			<div>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">所属项目:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 150px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点类型:</label>
				<el-select   v-model="filterForm.cmptType" style="width: 220px"> 
					<el-option label="全部" value="all"></el-option>
					<el-option v-for="(item,index) in cmptTypeList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				</el-select>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点搜索:</label>
				<el-input style="width: 180px;" placeholder="输入点名称/编号" v-model="filterForm.search_word">
				</el-input>
				<el-button style="margin-left: 15px;" @click="queryBtn()">查询</el-button>
			</div>
		</el-col>
		<el-col :span="24" class="toolbar" style="padding: 0px;padding-bottom:2px;margin: 5px 0px;">
			<el-button v-if="permissionNodeList.FAS_add.hasEntitle == 1" @click="handleAdd">新增点</el-button>
			<el-button v-if="permissionNodeList.FAS_del.hasEntitle == 1" @click="handleBatchDelete">删除点</el-button>
			<el-button v-if="permissionNodeList.FAS_import.hasEntitle == 1" @click="handleBatchImport">批量导入</el-button>
			<el-button v-if="permissionNodeList.FAS_export.hasEntitle == 1" @click="exportData">数据导出</el-button>
		</el-col>
		<el-dialog title="批量导入项目" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column  type="selection" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="120" sortable>
			</el-table-column>
			<el-table-column prop="name" label="点名称" width="180" sortable>
			</el-table-column>
			<el-table-column prop="sn" label="点编号" width="160"  sortable>
			</el-table-column>
			<el-table-column prop="cmptTypeName" label="点类型" width="140" sortable>
			</el-table-column>
			<el-table-column prop="address" label="点地址" width="150" sortable>
			</el-table-column>
			<el-table-column prop="sysCodeName" label="所属系统" min-width="150" sortable>
			</el-table-column>
			<el-table-column label="操作" width="100">
				<template scope="scope">
					<el-button size="small" v-if="permissionNodeList.FAS_edit.hasEntitle == 1" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增界面-->
		<el-dialog title="新增FAS点位" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="saveFormRules" ref="addForm">
				<el-form-item prop="name" label="点名称">
					<el-input v-model="addForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="点编号">
					<el-input v-model="addForm.sn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="点地址">
					<el-input v-model="addForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="点类型"  prop="cmptType">
					<el-select   v-model="addForm.cmptType" style="width: 300px"> 
						<el-option v-for="(item,index) in cmptTypeList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="addForm.projectId"  filterable placeholder="请选择" style="width: 300px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="系统类型"  prop="sysCode">
					<el-select  v-model="addForm.sysCode" placeholder="请选择" style="width: 300px">
				        <el-option v-for="(item,index) in sysAppList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				    </el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="saveFormRules" ref="editForm">
				<el-form-item prop="name" label="点名称">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="点编号">
					<el-input v-model="editForm.sn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="点地址">
					<el-input v-model="editForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="点类型"  prop="cmptType">
					<el-select   v-model="editForm.cmptType" style="width: 300px"> 
						<el-option v-for="(item,index) in cmptTypeList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="editForm.projectId"  filterable placeholder="请选择" style="width: 300px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="系统类型"  prop="sysCode">
					<el-select  v-model="editForm.sysCode" placeholder="请选择" style="width: 300px">
				        <el-option v-for="(item,index) in sysAppList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				    </el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled"  @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				permissionNodeList:global.getPermissionNodeList(),
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				cmptTypeList:[],
				editFormVisible: false,
				editLoading: false,
				saveFormRules: {
					name: [
						{ required: true, message: '点名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					cmptType: [
						{ required: true, message: '请选择点类型'},
					],
					sn: [
						{ required: true, message: '点编号不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					address: [
						{ required: true, message: '点地址不能为空', trigger: 'blur' },
					],
					projectId:[
					    { required: true, message: '请选择所属项目'},
					],
					sysCode:[
					    { required: true, message: '请选择系统类型'},
					]
				},
				addForm: {

				},
				editForm: {

				},
				filterForm: {
					
				},
				sysAppList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/fas/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterCmptType:'',
				projectList:[],
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					keys:this.search_word,
					pageNum: this.page,
					pageSize: 15
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterCmptType && this.filterCmptType.length>0) param.cmptType = this.filterCmptType;
				this.listLoading = true;
				api.assetsManage_fas_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleEdit: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_fas_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.editForm = Object.assign({}, res.data);
						this.editForm.projectId  = String(this.editForm.projectId);
					}
					else{
						tools.error(new Vue(),"没有查询到该设备详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.editFormVisible = true;
				this.listLoading = false;
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				if(null != param.cmptType){
					if(param.cmptType == 'all')this.filterCmptType = '';
					else this.filterCmptType = param.cmptType;
				}
				this.get_list_data();
			},
			handleAdd: function () {
				let param = {};
				this.addFormVisible = true;
				this.addForm = {
				};	
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = Object.assign({}, this.addForm);
						param.projectId = parseInt(param.projectId);
						this.listLoading = true;
						let self = this;
						api.assetsManage_fas_saveOrUpdate_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
            },
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						let param = Object.assign({}, this.editForm);
						param.projectId = parseInt(param.projectId);
						this.listLoading = true;
						let self = this;
						api.assetsManage_fas_saveOrUpdate_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			getSysAppList: function () {
				let param = {};
				api.assetsManage_fas_getSysAppList_request(param).then((res) => {
					this.sysAppList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
			},
			getCmptTypeList: function () {
				let param = {sysSource:'FAS'};
				api.normalData_getTypeList_request(param).then((res) => {
					if(res.data){
						this.cmptTypeList = res.data;	
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseInt(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					    console.log(temp);
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			handleBatchDelete:function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择要删除的数据");
					return
				}
				this.$confirm('确认删除吗?', '提示', {showClose:false}).then(() => {
				    let param = {ids:this.tableSelectionIds};
					api.assetsManage_fas_batchRemove_request(param).then(
						res => {
							if(res.code == 200){
								tools.success(this,"删除成功");
							    this.get_list_data();
							}
							else{
								tools.error(new Vue(),res.msg);
							}
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });	
				})
				.catch(function(e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				 });
			},
			downloadTemplate(){
				let param = {};
				api.assetsManage_fas_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_assetsManageFASList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleUploadExceed(files, fileList){
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					keys:this.filterForm.search_word,
				};
				if(null != this.filterForm.cmptType){
					if(this.filterForm.cmptType == 'all')this.filterCmptType = '';
					else this.filterCmptType = this.filterForm.cmptType;
				}
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterCmptType && this.filterCmptType.length>0) param.cmptType = this.filterCmptType;
				this.listLoading = true;
				api.assetsManage_fas_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'assetsManageFASList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				this.listLoading = true;
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			}
		},
		mounted() {
			this.get_list_data();
			this.getSysAppList();
			this.getCmptTypeList();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// fas_list.vue?34db709b